"use strict";
/* globals module */
/**
 * @module mediaGalleryInstanceFilesBatchClient
 * @description  Media Gallery Instance Files Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var httpApi_1 = require("../../../httpApi");
var __1 = require("../");
var MediaGalleryInstanceFilesBatchClient = /** @class */ (function () {
    function MediaGalleryInstanceFilesBatchClient(mediaGalleryInstanceFilesBatchRoute, apiClient) {
        this.mediaGalleryInstanceFilesBatchRoute = mediaGalleryInstanceFilesBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MediaGalleryInstanceFilesBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.mediaGalleryInstanceFilesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove file resources from the system if successfully completed. Specified file and all its accompanying derived resources will be removed from the system.
     * @method
     * @param mediaGalleryId Media Gallery file id of the original media gallery file used to identify media gallery files on which delete action should be performed.
     * @param data Collection of media gallery delete requests which uniquely identifies media gallery files that need to be deleted.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // Remove original file resources
                   mediaGalleryInstanceFilesBatchClient.unlink([{ id: '<file-id>' }])
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
    **/
    MediaGalleryInstanceFilesBatchClient.prototype.unlink = function (mediaGalleryId, data) {
        return this.apiClient.delete(this.mediaGalleryInstanceFilesBatchRoute.unlink(mediaGalleryId), undefined, data);
    };
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates specified file resources.
     * @method
     * @param mediaGalleryId Media Gallery id which uniquely identifies media gallery whose media gallery file need to be updated.
     * @param data Media Gallery file object that need to be updated in the system.
     * @returns A promise that is resolved once the update action has been performed.
     * @example mediaGalleryInstanceFilesBatchClient.update('<media-gallery-id>', files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    MediaGalleryInstanceFilesBatchClient.prototype.update = function (mediaGalleryId, data) {
        return this.apiClient.put(this.routeDefinition.update(mediaGalleryId), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resources from other modules into the Files module (For example: file resources from the Media Vault module can be linked directly into the Files module).
     * @method
     * @param mediaGalleryId Media Gallery slug or id which uniquely identifies media gallery whose media gallery files need to be linked.
     * @param data A collection of media gallery file objects that need to be inserted into the system.
     * @returns A promise that is resolved once the link action has been performed.
     * @example mediaGalleryInstanceFilesBatchClient.link(files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    MediaGalleryInstanceFilesBatchClient.prototype.link = function (mediaGalleryId, data) {
        return this.apiClient.post(this.routeDefinition.link(mediaGalleryId), this.routeDefinition.createParams(data));
    };
    var _a, _b;
    MediaGalleryInstanceFilesBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.MediaGalleryInstanceFilesBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.MediaGalleryInstanceFilesBatchRoute !== "undefined" && __1.MediaGalleryInstanceFilesBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MediaGalleryInstanceFilesBatchClient);
    return MediaGalleryInstanceFilesBatchClient;
}());
exports.MediaGalleryInstanceFilesBatchClient = MediaGalleryInstanceFilesBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/
